import * as React from 'react';

export const Component = React.forwardRef<any, any>(
  ({ children, renderAs, ...props }, ref) =>
    React.createElement(renderAs, { ...props, ref }, children),
);
